import './hack.ts';

import Eruda from 'eruda';

const Storage = import.meta.env.DEV ? localStorage : sessionStorage;

const key = 'show-eruda';

export function toggle() {
  Storage.setItem(key, Storage.getItem(key) === 'true' ? 'false' : 'true');
  window.location.reload();
}

if (
  !import.meta.env.WATCHING &&
  (import.meta.env.DEV || Storage.getItem(key) === 'true')
) {
  Eruda.init();
}
